import { apiService } from './api';
import { HardwareConfig } from '../components/dashboard/OnPremiseMigrationEstimate';

export interface HardwareConfigResponse extends HardwareConfig {
  id: number;
  userId: number;
  name: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export const hardwareConfigService = {
  // Get all configs for the user
  async getConfigs(): Promise<HardwareConfigResponse[]> {
    const { data } = await apiService.get<HardwareConfigResponse[]>('/hardware-config');
    return data;
  },

  // Get default config (creates one if doesn't exist)
  async getDefaultConfig(): Promise<HardwareConfigResponse> {
    const { data } = await apiService.get<HardwareConfigResponse>('/hardware-config/default');
    return data;
  },

  // Create a new config
  async createConfig(config: HardwareConfig & { name?: string; isDefault?: boolean }): Promise<HardwareConfigResponse> {
    const { data } = await apiService.post<HardwareConfigResponse>('/hardware-config', config);
    return data;
  },

  // Update the default config (simplified endpoint for dashboard)
  async updateDefaultConfig(config: HardwareConfig): Promise<HardwareConfigResponse> {
    const { data } = await apiService.put<HardwareConfigResponse>('/hardware-config/default', config);
    return data;
  },

  // Update a specific config
  async updateConfig(id: number, config: Partial<HardwareConfig> & { name?: string; isDefault?: boolean }): Promise<HardwareConfigResponse> {
    const { data } = await apiService.put<HardwareConfigResponse>(`/hardware-config/${id}`, config);
    return data;
  },

  // Delete a config
  async deleteConfig(id: number): Promise<{ message: string }> {
    const { data } = await apiService.delete<{ message: string }>(`/hardware-config/${id}`);
    return data;
  }
};